function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState } from 'react';
import { useMap, useMapEvents } from '@manifesto-tech/react-leaflet';
import CenterPopup from './CenterPopup.jsx';
import { decodeHTMLEntities } from '../utils/utilities';
var Card = function Card(_ref) {
  var type = _ref.type,
    image = _ref.image,
    name = _ref.name,
    description = _ref.description,
    linkText = _ref.linkText,
    linkUrl = _ref.linkUrl,
    position = _ref.position;
  var map = useMap();
  var _useState = useState(map.getZoom()),
    _useState2 = _slicedToArray(_useState, 2),
    zoom = _useState2[0],
    setZoom = _useState2[1];
  var _useState3 = useState(map.getCenter()),
    _useState4 = _slicedToArray(_useState3, 2),
    center = _useState4[0],
    setCenter = _useState4[1];
  var directions = "https://www.google.com/maps/dir//".concat(position.join(','), "/@").concat(center.lat, ",").concat(center.lng, ",").concat(zoom, "z");
  useMapEvents({
    zoom: function zoom(_ref2) {
      var target = _ref2.target;
      setZoom(target.getZoom());
      setCenter(target.getCenter());
    },
    drag: function drag(_ref3) {
      var target = _ref3.target;
      setCenter(target.getCenter());
    }
  });
  return /*#__PURE__*/React.createElement(CenterPopup, {
    className: "font-sans"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-base"
  }, image && /*#__PURE__*/React.createElement("div", {
    className: "w-full"
  }, /*#__PURE__*/React.createElement("img", {
    src: decodeHTMLEntities(image),
    className: "w-full h-full"
  })), /*#__PURE__*/React.createElement("div", {
    className: "p-4 md:p-6"
  }, type && /*#__PURE__*/React.createElement("div", {
    className: "mb-3 text-2xs lg:text-sm uppercase font-semibold tracking-widest text-grey",
    dangerouslySetInnerHTML: {
      __html: type
    }
  }), name && /*#__PURE__*/React.createElement("h3", {
    className: "text-h3 text-black font-medium mb-4",
    dangerouslySetInnerHTML: {
      __html: name
    }
  }), description && /*#__PURE__*/React.createElement("div", {
    className: "o-map__card-description prose prose-inherit max-sm:text-sm lg:text-lg text-grey",
    dangerouslySetInnerHTML: {
      __html: description
    }
  }), directions && /*#__PURE__*/React.createElement("a", {
    className: ['o-map__card-link', 'o-map__card-link--directions', 'a-button', 'a-button--secondary', 'a-button--grey', 'mb-2.5'].join(' '),
    href: directions,
    target: "_blank",
    rel: "noreferrer"
  }, "Get directions"), linkUrl && linkText && /*#__PURE__*/React.createElement("a", {
    className: "o-map__card-link a-button a-button--primary a-button--grey",
    href: linkUrl
  }, linkText))));
};
export default Card;